module.exports = __webpack_public_path__ + "media/images/icons/calendar-b2d467df0e01fe5d66cc5e72093d964a.svg";